import { Link, useLocation } from 'react-router-dom';
import SEOHead from '../components/SEOHead';
import { SUPPORT_EMAIL, SALES_MAILTO } from '../lib/publicSite';

const PAGES = {
  '/privacy': {
    title: 'Privacy Policy (draft)',
    heading: 'Privacy Policy',
    summary: 'This draft describes how WorkStream Pro handles account and work-order data. It is not a finished privacy policy.',
  },
  '/terms': {
    title: 'Terms of Service (draft)',
    heading: 'Terms of Service',
    summary: 'This draft describes the intended rules for using WorkStream Pro. It is not a finished contract.',
  },
  '/cookies': {
    title: 'Cookie Policy (draft)',
    heading: 'Cookie Policy',
    summary: 'This draft describes cookies the app uses to keep you signed in. It is not a finished cookie policy.',
  },
};

const LegalDraftPage = () => {
  const { pathname } = useLocation();
  const page = PAGES[pathname] || PAGES['/privacy'];

  return (
    <div className="min-h-screen bg-slate-950 text-slate-200">
      <SEOHead
        title={`${page.title} | WorkStream Pro`}
        description={`${page.summary} Pending legal review.`}
        canonical={`https://workstreampro.us${pathname}`}
      />
      <header className="border-b border-slate-800">
        <div className="max-w-3xl mx-auto px-6 py-5 flex items-center justify-between">
          <Link to="/" className="text-xl font-bold text-white">WorkStream Pro</Link>
          <Link to="/" className="text-sm text-amber-400 hover:text-amber-300">Back to home</Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-10">
        <p className="inline-block bg-amber-500/15 text-amber-300 border border-amber-500/40 rounded px-3 py-1 text-sm font-semibold mb-6">
          Draft for legal review — not legal advice and not a final policy
        </p>
        <h1 className="text-4xl font-bold text-white mb-4">{page.heading}</h1>
        <p className="text-lg text-slate-300 mb-8">{page.summary}</p>

        <section className="space-y-4 text-slate-300 leading-relaxed">
          <h2 className="text-xl font-semibold text-white">What this draft covers</h2>
          <ul className="list-disc pl-5 space-y-2">
            <li>Account information you submit, such as name, email, and company name.</li>
            <li>Work records you enter, such as work orders, locations, inventory, and notes.</li>
            <li>A sign-in cookie used to keep your session. It is not used to sell a profile of you.</li>
            <li>Billing is handled by Stripe when a company checks out. WorkStream Pro does not store full card numbers.</li>
          </ul>
          <h2 className="text-xl font-semibold text-white pt-4">What a lawyer still needs to confirm</h2>
          <ul className="list-disc pl-5 space-y-2">
            <li>The legal entity name, address, and governing law.</li>
            <li>Retention periods, subprocessors, and international transfer language.</li>
            <li>Whether any analytics cookies need a consent banner beyond this page.</li>
            <li>Subscription terms, refunds, and acceptable use.</li>
          </ul>
          <p>
            Questions about this draft: <a className="text-amber-400 hover:text-amber-300" href={SALES_MAILTO}>{SUPPORT_EMAIL}</a>.
          </p>
        </section>
      </main>
    </div>
  );
};

export default LegalDraftPage;
